var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"createProductCategoryModal",attrs:{"title":"Créer categorie"}},[_c('category-create-or-update-form',{attrs:{"parent-id":_vm.parentId,"mode":"create"},on:{"done":function($event){return _vm.closeModal()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }